export const ROUTE_NAMES = {
  // Public routes
  allEvents: (orgId: number | string) => `/organizations/${orgId}/opportunities`,
  eventDetails: (orgId: number | string, eventId: number | string) =>
    `/organizations/${orgId}/opportunities/${eventId}`,
  occurrenceDetails: (orgId: number | string, encodedOccurrence: string) =>
    `/organizations/${orgId}/opportunities/${encodedOccurrence}`,
  allEventsPage: (orgId: number | string) => `/organizations/${orgId}/all-events`,
  calendar: (orgId: number | string, viewType: string = 'month') => `/organizations/${orgId}/calendar/${viewType}`,
  eventRegistrationRefactor: (orgId: number | string, encodedOccurrence: string, token?: string) =>
    `/organizations/${orgId}/opportunities/${encodedOccurrence}/event-registration${token ? '/' + token : ''}`,
  stableLinkRegistration: (orgId: number | string, stableLinkCode: string) =>
    `/organizations/${orgId}/event_links/${stableLinkCode}/registration`,
  notFound: () => '/not-found',

  // User routes
  myEvents: (orgId: number | string) => `/organizations/${orgId}/my/activities`,
  myEventDetails: (orgId: number | string, eventId: number | string) => `/organizations/${orgId}/activities/${eventId}`,
}
